import { render, staticRenderFns } from "./GynecologyForm.vue?vue&type=template&id=58e356e4&"
import script from "./GynecologyForm.vue?vue&type=script&lang=js&"
export * from "./GynecologyForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports